import { FC } from "react";
import styles from "./confirm.module.scss";
import { Modal } from "../modal/Modal";
import { Button } from "../button/Button";

type Props = {
  confirm: () => void;
  reject: () => void;
  text?: string;
  isProcessing?: boolean;
};
export const Confirm: FC<Props> = ({
  confirm,
  reject,
  text = "",
  isProcessing = false,
}) => {
  return (
    <Modal close={reject}>
      <div className={styles.confirm}>
        <h2>Подтвердите действие на странице</h2>
        <h4>{text}</h4>
        <div className={styles.actions}>
          <Button onClick={reject} isDisabled={isProcessing}>
            Отменить
          </Button>
          <Button
            onClick={confirm}
            isDisabled={isProcessing}
            isProcessing={isProcessing}
          >
            Продолжить
          </Button>
        </div>
      </div>
    </Modal>
  );
};
